"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MouthType;
(function (MouthType) {
    MouthType["Concerned"] = "Concerned";
    MouthType["Default"] = "Default";
    MouthType["Disbelief"] = "Disbelief";
    MouthType["Eating"] = "Eating";
    MouthType["Grimace"] = "Grimace";
    MouthType["Sad"] = "Sad";
    MouthType["ScreamOpen"] = "ScreamOpen";
    MouthType["Serious"] = "Serious";
    MouthType["Smile"] = "Smile";
    MouthType["Tongue"] = "Tongue";
    MouthType["Twinkle"] = "Twinkle";
    MouthType["Vomit"] = "Vomit";
})(MouthType || (MouthType = {}));
exports.default = MouthType;
